import EmblaCarousel from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";

export const addDotBtnsAndClickHandlers = (
  emblaApi,
  dotsNode,
  onButtonClick
) => {
  let dotNodes = [];

  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="cases__slider-dot" type="button"></button>')
      .join("");

    const scrollTo = (index) => {
      emblaApi.scrollTo(index);
      if (onButtonClick) onButtonClick(emblaApi);
    };

    dotNodes = Array.from(dotsNode.querySelectorAll(".cases__slider-dot"));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener("click", () => scrollTo(index), false);
    });
  };

  const toggleDotBtnsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotNodes[previous].classList.remove("cases__slider-dot--selected");
    dotNodes[selected].classList.add("cases__slider-dot--selected");
  };

  emblaApi
    .on("init", addDotBtnsWithClickHandlers)
    .on("reInit", addDotBtnsWithClickHandlers)
    .on("init", toggleDotBtnsActive)
    .on("reInit", toggleDotBtnsActive)
    .on("select", toggleDotBtnsActive);

  return () => {
    dotsNode.innerHTML = "";
  };
};

class CasesClass {
  init() {
    const emblaNode = document.querySelector("#cases-slider");
    const plugins = [Autoplay()];

    const dotsNode = document.querySelector(".cases__slider-dots");
    const emblaApi = EmblaCarousel(
      emblaNode,
      {
        loop: false,
        dragFree: false,
        slidesToScroll: 2,
        breakpoints: {
          "(max-width: 1100px)": { slidesToScroll: 1 },
        },
      },
      plugins
    );

    const onNavButtonClick = (emblaApi) => {
      const autoplay = emblaApi?.plugins()?.autoplay;
      if (!autoplay) return;

      const resetOrStop =
        autoplay.options.stopOnInteraction === false
          ? autoplay.reset
          : autoplay.stop;

      resetOrStop();
    };

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
      emblaApi,
      dotsNode,
      onNavButtonClick
    );

    emblaApi.on("destroy", removeDotBtnsAndClickHandlers);
  }
}

export const Cases = new CasesClass();
